import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-placeholder',
  templateUrl: './admin-placeholder.component.html',
  styleUrls: ['./admin-placeholder.component.scss']
})
export class AdminPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
